export default () => {
  document.querySelector(".tabcontent.active > .collapse-container > .bfg-collapse").click();
};
